import { FeatureFlags } from "@/plugins/launchDarkly/featureFlags";
import { defineComponent } from "vue";
import { RouteRecordRaw } from "vue-router";

const PlaceholderComponent = defineComponent({
  template: `
    <div class="q-pa-md">
      <h4>Page Under Development</h4>
      <p>This page is currently under development.</p>
    </div>
  `
});

export const importhubRoutes: RouteRecordRaw[] = [
  {
    path: '/import-hub',
    name: 'Import Hub',
    component: () => PlaceholderComponent,
    meta: {
      requiresAuth: true,
      navigation: {
        label: 'Import Hub',
        icon: 'arrow-down-tray-icon.svg',
        order: 3,
        showInMenu: true,
        featureFlag: FeatureFlags.IMPORT_HUB,
        permissions: {
          ownerRoles: ['Publisher'],
        }
      }
    },
    children: [
      {
        path: 'import/',
        name: 'Import',
        component: () => PlaceholderComponent,
        meta: {
          title: "Import",
          requiresAuth: true,
          navigation: {
            parent: 'Import Hub',
            label: 'Import',
            featureFlag: FeatureFlags.IMPORT_HUB,
            order: 1,
            showInMenu: true,
          }
        }
      }
    ]
  }
];
